import { render, staticRenderFns } from "./ExpandableMenuList.vue?vue&type=template&id=bca32d98&scoped=true&"
import script from "./ExpandableMenuList.vue?vue&type=script&lang=js&"
export * from "./ExpandableMenuList.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableMenuList.vue?vue&type=style&index=0&id=bca32d98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca32d98",
  null
  
)

export default component.exports